"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _theme = _interopRequireDefault(require("../../../theme"));

var _Box = _interopRequireDefault(require("../../Box"));

var _TableRow = _interopRequireDefault(require("./TableRow"));

var _TableContext = _interopRequireDefault(require("./TableContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var BodyEl = (0, _styledComponents["default"])(_Box["default"]).withConfig({
  displayName: "TableBody__BodyEl",
  componentId: "sc-12rcv9s-0"
})(["overflow-y:auto;overflow-x:hidden;", ":nth-child(even){background-color:", ";}"], _TableRow["default"], function (props) {
  return props.theme.colors.neutral[100];
});
var TableBody = (0, _react.forwardRef)(function (props, ref) {
  var context = _react["default"].useContext(_TableContext["default"]);

  return _react["default"].createElement(BodyEl, _extends({
    ref: ref
  }, props));
});
TableBody.defaultProps = {
  theme: _theme["default"]
};
var _default = TableBody;
exports["default"] = _default;